import Upload from './upload';

export default class UploadService {
  constructor($http) {
    this.teste = 'Hello World';
    this.$http = $http;
  }

  createUpload() {
    return new Upload(this.$http);
  }
}



// WEBPACK FOOTER //
// ./src/upload.service.js